const FLOW = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#00EF8B"
    />
    <path d="M14.3803 8.44H11.5603V11.26H14.3803V8.44Z" fill="white" />
    <path
      d="M8.74004 12.32C8.74004 12.9 8.26004 13.38 7.68005 13.38C7.10005 13.38 6.62005 12.9 6.62005 12.32C6.62005 11.74 7.10005 11.26 7.68005 11.26H8.74004V8.44H7.68005C5.54005 8.44 3.80005 10.18 3.80005 12.32C3.80005 14.46 5.54005 16.2 7.68005 16.2C9.82004 16.2 11.56 14.46 11.56 12.32V11.26H8.74004V12.32Z"
      fill="white"
    />
    <path
      d="M12.62 7.02001H15.8V4.20001H12.62C10.48 4.20001 8.73999 5.94001 8.73999 8.08001V8.44001H11.56V8.08001C11.56 7.50001 12.04 7.02001 12.62 7.02001Z"
      fill="white"
    />
    <path d="M11.56 8.44H8.73999V11.26H11.56V8.44Z" fill="#16FF99" />
  </svg>
);
export default FLOW;
